/**
 * @flow
 */

import React from 'react'
import queryString from 'query-string'
import CloseModalIcon from '../../Icons/CloseModalIcon'
import BookingDetails from './BookingDetails'
import SuccessFormMessage from './SuccessFormMessage'
import {
  SuccessFormDesktopContainer,
  SuccessfulFormDesktopSection,
  VerticalLine,
  BookAnotherDesktopButtonContainer,
  BookAnotherText,
  CloseModalIconContainer,
  Wrapper,
  MapBackground,
  BookAnotherArrowIcon
} from './styledComponents'

class SuccessFormDesktop extends React.Component<Props> {
  queryParams = { arcades: '' }
  render() {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      this.queryParams = queryString.parse(window.location.search)
    }
    const {
      closeLightBox,
      closeLightBoxAndCloseMobileFormModal,
      bookingResponseData,
      bookingInfo,
      amanoraSectionDetails
    } = this.props
    const {
      bookAnotherButtonText,
      thankYouWishes,
      thankYouMessage,
      bookingDetailsHeading,
      continueButtonText
    } = bookingResponseData
    const { arcadeMapUrl } = amanoraSectionDetails
    const GOOGLE_MAP_EMBED_URL = `${arcadeMapUrl}&disable_scroll=true&t=m`
    return (
      <Wrapper>
        <SuccessFormDesktopContainer>
          <SuccessfulFormDesktopSection id={`slot-booking-success-modal`}>
            <CloseModalIconContainer
              onClick={closeLightBoxAndCloseMobileFormModal}
            >
              <CloseModalIcon />
            </CloseModalIconContainer>
            <div>
              <SuccessFormMessage
                slotId={bookingInfo.slotId}
                thankyouWishes={thankYouWishes}
                thankyouMessage={thankYouMessage}
              />
              <BookAnotherDesktopButtonContainer
                onClick={closeLightBox}
                id="book-another"
              >
                <BookAnotherText>{bookAnotherButtonText}</BookAnotherText>
                <BookAnotherArrowIcon />
              </BookAnotherDesktopButtonContainer>
            </div>
            <VerticalLine />
            <BookingDetails
              bookingResponseData={bookingResponseData}
              closeLightBox={closeLightBoxAndCloseMobileFormModal}
              bookingDetailsHeading={bookingDetailsHeading}
              continueButtonText={continueButtonText}
              personName={bookingInfo.name}
              mobileNumber={bookingInfo.mobileNumber}
              noOfPeople={bookingInfo.noOfPeople}
              packageBooked={bookingInfo.package}
              dateOfBooking={
                bookingInfo.dateOfBooking !== '' &&
                (this.queryParams.arcades === 'bhowanipore'
                  ? bookingInfo.dateOfBooking.format('DD MM YYYY, h:mm a')
                  : bookingInfo.dateOfBooking.format('DD MM YYYY'))
              }
            />
            <MapBackground
              title="Amanora mall"
              src={GOOGLE_MAP_EMBED_URL}
              frameBorder={0}
              marginHeight={0}
              marginWidth={0}
            />
          </SuccessfulFormDesktopSection>
        </SuccessFormDesktopContainer>
      </Wrapper>
    )
  }
}

export default SuccessFormDesktop



// WEBPACK FOOTER //
// ./src/components/IbcArcade/BookingResponseMessage/index.desktop.js